import React from 'react';
import { Button } from './ui/button';
import { useLanguage } from '../hooks/useLanguage';

const FinalCTA = () => {
  const { t } = useLanguage();

  return (
    <section className="py-24 bg-gradient-to-r from-accent-500 to-accent-600 text-white text-center relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <h2 className="text-4xl md:text-6xl font-bold mb-6 tracking-tight">
          {t('sections.finalCtaTitle')}
        </h2>
        <p className="text-xl md:text-2xl text-white/90 mb-10 max-w-2xl mx-auto">
          {t('sections.finalCtaSubtitle')}
        </p>
        <Button 
          size="lg" 
          className="bg-white text-accent-600 hover:bg-gray-100 font-bold text-xl px-12 py-8 h-auto rounded-full shadow-xl hover:shadow-2xl hover:scale-105 transition-all"
          onClick={() => document.getElementById('offers').scrollIntoView({ behavior: 'smooth' })}
        >
          {t('sections.finalCtaBtn')}
        </Button>
      </div>
    </section>
  );
};

export default FinalCTA;
